module.exports = __webpack_public_path__ + "static/013.thumb-9c9e16acfb12d012a2f56bf763e5fb19.jpg";